module.exports = __webpack_public_path__ + "img/home-lighter.f9c14973.svg";